const styles = {
  grid: {
    backgroundColor: '#fff',
    borderBottom: '.125rem solid rgba(0, 0, 0, 0.3)',
    display: 'grid',
    width: 'calc(100% - (5.75rem))',
    height: '22.375rem',
    position: 'absolute !important',
    marginLeft: '3.75rem',
    opacity: 0.25,
    zIndex: '0',
  },
  gridElement: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100% !important',
    border: '.0625rem solid rgba(0, 0, 0, 0.3)',
    borderTop: 'none',
    borderBottom: 'none',
    position: 'relative',
    '&.weekend': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      color: '#000',
    },
  },
  colLabel: {
    position: 'absolute',
    transform: 'rotate(-90deg) !important',
  },
  colDate: {
    color: '#000',
    position: 'absolute',
    bottom: '-2rem',
    left: 0,
    fontSize: '.75rem',

    '&.firstOfMonth': {
      bottom: '-3rem !important',
    },

    '&.lastDay': {
      right: 0,
      left: 'auto',

      '&.monthly': {
        bottom: '-3rem !important',
      },
    },
  },
  day: {
    margin: '0',
    padding: '0',
    lineHeight: '1.1',
  },
  month: {
    marginTop: '.25rem',
    padding: '0',
    lineHeight: '1.1',
  },
};

export default styles;
